import {isNil} from 'ramda';

import {CustomerResponseBodyV2} from '@dms/api/customer';

import {EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

import {getNaturalPersonFullName} from './getNaturalPersonFullName';
import {isCustomerNaturalPerson} from './isCustomerNaturalPerson';

type CustomerNameSource = Pick<
  CustomerResponseBodyV2,
  'discriminator' | 'foundingPerson' | 'businessInfo'
>;

export function getCustomerName(customer: CustomerNameSource | Nullish): string | undefined {
  if (isNil(customer)) {
    return undefined;
  }

  if (isCustomerNaturalPerson(customer)) {
    return getNaturalPersonFullName(customer?.foundingPerson) ?? EMPTY_PLACEHOLDER;
  }

  return customer.businessInfo?.businessInfo?.tradeName ?? EMPTY_PLACEHOLDER;
}
